<script setup lang="ts">
import { Button } from '@/components/ui/button';

withDefaults(defineProps<{
  to: string;
  label: string;
  icon: string;
  active?: boolean;
  count?: number;
}>(), {
  active: false,
  count: 0,
});
</script>

<template>
  <Button
    as-child
    :variant="active ? 'secondary' : 'ghost'"
    class="w-full justify-start gap-3 rounded-xl px-4 py-3 text-muted-foreground data-[active=true]:text-primary"
    :data-active="active ? 'true' : 'false'"
  >
    <NuxtLink :to="to" :aria-current="active ? 'page' : undefined">
      <Icon :name="icon" class="size-5 shrink-0" aria-hidden="true" />
      <span class="min-w-0 flex-1">{{ label }}</span>
      <span
        v-if="count > 0"
        class="ml-auto text-xs font-medium text-primary"
      >
        {{ count > 9 ? '9+' : count }}
      </span>
    </NuxtLink>
  </Button>
</template>
